import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { path } from 'ramda';
import { withAsyncActions } from 'react-async-client';
import { NavLink } from 'react-router-dom';

import { ACTION_SIDEBAR } from 'constants/sidebarTypes';
import { SidebarLink } from 'components/common/tableComponents/cellTemplates';

import { fullAutoOptions } from 'constants/asyncClient';
import { getActionList, getUser } from 'actions/asyncActions';
import { personTimetable } from 'constants/routes';

@connect(state => ({ user: getUser.selectData(state) }))
@withAsyncActions({
    getList: getActionList
        .withPayload(props => ({
            user: props.user.id
        }))
}, fullAutoOptions)
export default class ActionListTable extends Component {
    static propTypes = {
        getList: PropTypes.object.isRequired,
        renderTable: PropTypes.func.isRequired,
    }

    tableColumns = [
        {
            name: 'sidebarActionLink',
            width: 50,
            additionalClass: 'p-l-15',
            template: ({ item: { project } }) => (
                <SidebarLink
                    componentName={ACTION_SIDEBAR}
                    item={project}
                    icon="case"
                    value={path(['name'], project)}
                />
            ),
        },
        {
            name: 'number',
            width: 45,
            template: ({ rowIndex }) => rowIndex + 1,
        },
        {
            name: 'project',
            label: <Translate content="education.action.headers.project" />,
            template: ({ item: { project } }) => (
                <NavLink to={personTimetable.stringify({ project: project.id })}>
                    {path(['name'], project)}
                </NavLink>
            )
        },
        {
            name: 'stage',
            width: 250,
            label: <Translate content="education.action.headers.stage" />,
            template: path(['item', 'stage', 'name']),
        },
    ];

    render() {
        const { getList, renderTable: Table } = this.props;

        return (
            <Table {...getList} data={getList.data.actions} columns={this.tableColumns} />
        );
    }
}
